import useCategoryHook from "@/shared/hooks/useCategoryHook";
import { useTranslation } from "react-i18next";
import SelectList from "./SelectList";
import { Garnish, Product } from "@/shared/utils/interfaces";
import { useSetModal } from "@/shared/atoms/useModal";
import { UseQueryResult } from "@tanstack/react-query";

interface SelectedProps {
  product: Product;
  query: UseQueryResult<Garnish[], Error>;
}

const Selected = ({ product, query }: SelectedProps) => {
  const { t } = useTranslation();
  const { data: garnishes } = query;
  const { productUpdate } = useCategoryHook();
  const setModal = useSetModal();

  return (
    <div className="mt-16">
      <div className="text-[2.5rem] font-semibold mb-[2rem]">
        {t("menu.garnishSelect")}
      </div>

      {garnishes && (
        <SelectList
          isPending={productUpdate.isPending}
          onSubmit={(data) => {
            productUpdate.mutateAsync(
              { ...product, topping_categories: data },
              { onSuccess: () => setModal("", {}) }
            );
          }}
          garnishes={garnishes}
          defaultValue={product.sub_content}
        />
      )}
    </div>
  );
};

export default Selected;
